/**
 * /app/$tenantSlug/people/preboarding — Manage › People › Pre-boarding
 * (spec docs/superpowers/specs/2026-11-02-checklists-preboarding.md §4).
 *
 * The URL matches the backend's `preboarding_joining_day` notification link
 * (/people/preboarding). HR admins only (company_admin / hr_manager) behind
 * the hr_core module — the API re-checks both; the shell's HrFeatureGate and
 * the role check here are the UX mirror.
 *
 * ?filter=needs|all picks the list, ?joiner=<id> opens that joiner's panel.
 */

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { useHrRoles } from "@/components/hr/use-hr-roles";
import { JoinersPage } from "@/components/preboarding/joiners-page";
import { HrModuleShell } from "@/components/shared/hr-module-shell";
import { Card, CardContent } from "@/components/ui/card";

const searchSchema = z.object({
  filter: z.enum(["needs", "all"]).optional().catch(undefined),
  joiner: z.coerce.number().int().positive().optional().catch(undefined),
});

export const Route = createFileRoute("/_authgated/app/$tenantSlug/people/preboarding")({
  validateSearch: searchSchema,
  component: PreboardingRoute,
});

function PreboardingRoute() {
  const { isHrAdmin } = useHrRoles();
  const search = Route.useSearch();
  return (
    <HrModuleShell
      title="Pre-boarding"
      description="People who accepted an offer and haven't joined yet. An offer accepted in Hiring adds them here."
    >
      {isHrAdmin ? (
        <JoinersPage filter={search.filter ?? "needs"} joinerId={search.joiner} />
      ) : (
        <Card>
          <CardContent className="py-12 text-center text-sm text-muted-foreground">
            Pre-boarding is managed by HR admins.
          </CardContent>
        </Card>
      )}
    </HrModuleShell>
  );
}
